module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/plant-a-tree-2bf7db58e1ca5cf7561436023a02871b.jpg";